<template>
  
  <div class="py-4 container-fluid">
    <soft-alert v-show="notMail === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
      <strong>Error</strong> Email field must not be empty
    </soft-alert>
    <soft-alert id="notGenerated" v-show="notGenerated === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
      <strong>There was a problem</strong> Email couldn't be generated, try again!
    </soft-alert>
    <soft-alert v-show="noRelated === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
      <strong>No related emails were found</strong>, try again with another one!
    </soft-alert>
    <soft-alert v-show="copied === true" color="success" icon="ni ni-like-2 ni-lg" dismissible>
      <strong>Email copied</strong>, paste it wherever you want!
    </soft-alert>
    <soft-alert v-show="emailAdded === true" color="success" icon="ni ni-like-2 ni-lg" dismissible>
      <strong>Email added to Database</strong>, thanks for improving ToMate AI!
    </soft-alert>
    <soft-alert v-show="feedbackSent === true" color="success" icon="ni ni-like-2 ni-lg" dismissible>
      <strong>Feedback sent</strong>, thanks for improving ToMate AI!
    </soft-alert>
    <soft-alert v-show="error === true" color="danger" dismissible>
      <strong>Error</strong> there was a problem!
    </soft-alert>
    <div class="row">
      <div class="col-xl-6 col-12">
        <div class="row">
          <div class="col-12">
            <div class="card mb-4">
              <div class="form-group">
                <h6>Email</h6>
                <textarea
                  v-model="mail"
                  id="1"
                  class="form-control"
                  rows="10"
                  placeholder="Paste your mail here"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="card mb-4">
              <div class="form-group">
                <h6>Observations</h6>
                <textarea
                  v-model="observations"
                  id="2"
                  class="form-control"
                  rows="2"
                  placeholder="Write down any other observation you want to let the AI know"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-12">
        <div class="row">
          <div class="col-12">
            <div class="card mb-4">
              <div class="form-group" style="margin: 0">
                <div style="display: flex; align-items: center; gap: 15px; margin-bottom: 0.5rem; justify-content: space-between;">
                  <h6 style="margin: 0">Answer</h6> 
                  
                  <div style="display: flex; gap: 5px; align-items: center;">
                    <span id="showSimilaridad" class="text-sm mb-0" style="display: none; ">
                    </span>
                    <span id="showSimilarEmails" class="text-xs font-weight-bold" style="display: none; padding: 5px; background-color: #cb0c9f; color: #fff; border-radius: 20px;">
                      
                    </span>
                    <span id="showNewlyGenerated" class="text-xs font-weight-bold" style="display: none; padding: 5px; background-color: #17c1e8; color: #fff; border-radius: 20px;">
                      
                    </span>
                  </div>
                    
                </div>
                <textarea
                  id="respuesta"
                  class="form-control mb-2"
                  rows="15"
                  placeholder="The answer will appear here"
                ></textarea>
                <div id="relojito" style="height: 360px; display: none; justify-items: center; align-items: center;">
                  <div style="display: flex; align-items: center; gap: 5px;">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span>Doing our magic in real time...</span>
                  </div>
                </div>

                <div style="display: flex; justify-content: space-between; align-items: center;">
                  <a @click="copy()" class="btn" style="margin-bottom: 10px;">Copy</a>

                  <div style="display: flex; justify-items: center; gap: 10px; align-items: center; margin-bottom: 10px !important;">
                    <soft-button id="mostrarSubmitFeedback" @click="newEmailFeedback()" color="success" style="display: none;">
                      Submit as feedback
                    </soft-button>

                    <div id="feedback" style="display: none; justify-items: center; gap: 10px;">
                      <a @click="sendFeedback('OK')" style="cursor: pointer;">
                        <img width="20" height="20" src="https://img.icons8.com/ios-filled/50/cb0c9f/thumb-up--v1.png" alt="thumb-up--v1"/>
                      </a>

                      <a @click="sendFeedback('FAIL')" style="cursor: pointer;">
                        <img width="20" height="20" src="https://img.icons8.com/ios-filled/50/cb0c9f/thumbs-down.png" alt="thumbs-down"/>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>      
        </div>
      </div>
    </div>
    <div class="row" style="justify-content: center;">
      <div class="col-12" style="width: fit-content; ">
        <div class="card">
          <div style="display: flex; align-items: center; justify-content: center; gap: 10px; padding: 15px;">
            <select id="selectorTeam" class="btn" style="margin: 0px">
              <option v-for="(collection, index) of collections" :key="index" 
              :label="collection.name" :value="collection.token"></option>
            </select>
            <select id="selectorLength" class="btn" style="margin: 0px">
              <option selected value="short">Short</option>
              <option value="medium">Medium</option>
              <option value="large">Large</option>
            </select>
            <select id="selectorTono" class="btn" style="margin: 0px">
              <option value="formal">Formal</option>
              <option selected value="normal">Neutral</option>
              <option value="informal">Informal</option>
            </select>
            <soft-button id="botonTitular" color="success" @click="generate()">
              Get answer
            </soft-button>
            <soft-button id="botonSecundario" color="success" style="display: none">
              Get answer
            </soft-button>
          </div>
            
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SoftButton from "../components/SoftButton.vue"
  import SoftAlert from "../components/SoftAlert.vue"
  import HTFetch from "../llamadas/HTFetch"
  import K from "../../src/llamadas/K.js"

  export default {
    
    name: "generate",

    components: {
      SoftButton,
      SoftAlert,
    },

    data() {
      return {
        llamada: new HTFetch(),
        k: new K(),
        mail: "",
        notMail: false,
        observations: "",
        answer: "",
        loading: false,
        notGenerated: false,
        copied: false,
        noRelated: false,
        similaridad: 0,
        historico: 0,
        collections: [],
        emailAdded: false,
        feedbackSent: false,
        error: false
      }
    },

    mounted() {
      //this.llamada.ChkJWT()
      this.llamada.userInfo(this.userInfoRsp.bind(this))
    },

    methods: {
      generate() {
        let mostrarSubmitFeedback = document.getElementById("mostrarSubmitFeedback")
        mostrarSubmitFeedback.style.display = "none"

        this.historico = 0
        this.similaridad = 0

        if (this.mail.length === 0) {
          this.notMail = true

          setTimeout(() => {
            this.notMail = false
          }, 2000)
          return
        } 

        let extension = document.getElementById('selectorLength')
        let team = document.getElementById('selectorTeam')
        let tono = document.getElementById('selectorTono')

        let body = {
          "previous_email": this.mail,
          "custom_updates_notes": this.observations,
          "extension": extension.value,
          "tone": tono.value,
          "collection": team.value,
          "stream": true,
          "feedback": true,
          "debug": true
        }

        //this.loading = true

        let datos = {
            method: "POST",
            mode: "cors",
            referrerPolicy: 'strict-origin-when-cross-origin',
        };
        
        if (body) {
            datos.body = JSON.stringify(body);
            datos.headers = {
                'Authorization': 'Bearer ' + localStorage.ut,
                "Content-Type": "application/json",
            };
        }
        else
          datos.headers = { 'Authorization': 'Bearer ' + localStorage.ut, };

        let speedPerLetter = 0; // velocidad por letra en milisegundos
        let endpointUrl = `${this.k.WEBAPI_URL}actions/generate/`; // tu URL de endpoint aquí

        let similaridad = 0

        let relojito = document.getElementById("relojito")
        relojito.style.display = "grid"
        let resp = document.getElementById("respuesta")
        resp.style.display = "none"
        resp.value = ""

        let showSimilaridad = document.getElementById("showSimilaridad")
        showSimilaridad.style.display = "none"
        showSimilaridad.innerHTML = ""
        let showNewlyGenerated = document.getElementById("showNewlyGenerated")
        showNewlyGenerated.style.display = "none"
        showNewlyGenerated.innerHTML = ""
        let showSimilarEmails = document.getElementById("showSimilarEmails")
        showSimilarEmails.style.display = "none"
        showSimilarEmails.innerHTML = ""

        let botonTitular = document.getElementById("botonTitular")
        botonTitular.style.display = "none"
        let botonSecundario = document.getElementById("botonSecundario")
        botonSecundario.style.display = ""

        async function streamData() {
            const response = await fetch(endpointUrl, datos);

            if (!response.body) {
                throw new Error('El servidor no responde o el stream no es soportado');
            }

            if (response.status !== 200) {
              botonTitular.style.display = ""
              botonSecundario.style.display = "none"
              resp.style.display = ""
              relojito.style.display = "none"
              let notGenerated = document.getElementById('notGenerated')
              notGenerated.style.display = ''

              setTimeout(() => {
                notGenerated.style.display = 'none'
              }, 5000)
              return 
            }

            let feedback = document.getElementById("feedback")
            feedback.style.display = "flex"

            let mostrarSubmitFeedback = document.getElementById("mostrarSubmitFeedback")
            mostrarSubmitFeedback.style.display = ""

            const reader = response.body.getReader();
            const stream = new ReadableStream({
                start(controller) {
                    read();
                    async function read() {
                        const { done, value } = await reader.read();
                        if (done) {
                            controller.close();
                            return;
                        }

                        controller.enqueue(value);
                        read();
                    }
                }
            });

            const textDecoder = new TextDecoder();
            const data = stream.getReader();

            let chunkAux = ""
            let counter = 0

            // eslint-disable-next-line no-constant-condition
            while (true) {
                const { done, value } = await data.read();
                if (done) {
                    
                    break;
                }

                let chunk = textDecoder.decode(value);

                resp.style.display = ""
                relojito.style.display = "none"

                const breakPointRegex = '-'///\n+/; // Split the text into an array using the regular expression as the separator.
                const breakPoints = chunk.split(breakPointRegex); // Extract the first 3 break points and store them in an array.
                const firstThreeBreakPoints = breakPoints.slice(0, 3); // Log the first 3 break points and the array containing them.

                if (firstThreeBreakPoints[1] === 'False') {
                  showNewlyGenerated.style.display = ""
                  showNewlyGenerated.innerHTML = "Newly generated email"

                  similaridad = Math.round(parseFloat(firstThreeBreakPoints[2].split("\n")[1])*100)
                  showSimilaridad.innerHTML = `<i class="fa fa-check text-info" aria-hidden="true"></i> ` + similaridad.toString() + "% of similarity"
                  showSimilaridad.style.display = ""

                  localStorage.genId = firstThreeBreakPoints[0]

                  chunk = ""
                }
                
                if (firstThreeBreakPoints[1] === 'True') {
                  showSimilarEmails.style.display = ""
                  showSimilarEmails.innerHTML = "Based on team information"

                  similaridad = Math.round(parseFloat(firstThreeBreakPoints[2].split("\n")[1])*100)
                  showSimilaridad.innerHTML = `<i class="fa fa-check text-info" aria-hidden="true"></i> ` + similaridad.toString() + "% of similarity"
                  showSimilaridad.style.display = ""

                  localStorage.genId = firstThreeBreakPoints[0] 

                  chunk = ""
                }

                if (/[+-]?\d+(\.\d+)?/g.test(firstThreeBreakPoints[2])) {
                  
                  similaridad = Math.round(parseFloat(firstThreeBreakPoints[2]*100))
                  showSimilaridad.innerHTML = `<i class="fa fa-check text-info" aria-hidden="true"></i> ` + similaridad.toString() + "% of similarity"
                  showSimilaridad.style.display = ""

                  chunk = ""
                }

              //lo guardo en LS
              chunkAux = chunkAux + chunk
              localStorage.chunk = chunkAux

              /*if (counter < 5) {
                if (chunk.includes("False")) {
                  showNewlyGenerated.style.display = ""
                  showNewlyGenerated.innerHTML = "Newly generated email"

                  similaridad = Math.round(parseFloat(chunk.split("\n")[1])*100)
                  showSimilaridad.innerHTML = `<i class="fa fa-check text-info" aria-hidden="true"></i> ` + similaridad.toString() + "% of similarity"
                  showSimilaridad.style.display = ""

                  chunk = ""
                } 
                if (chunk.includes("True")) {
                  showSimilarEmails.style.display = ""
                  showSimilarEmails.innerHTML = "Based on team information"

                  similaridad = Math.round(parseFloat(chunk.split("\n")[1])*100)
                  showSimilaridad.innerHTML = `<i class="fa fa-check text-info" aria-hidden="true"></i> ` + similaridad.toString() + "% of similarity"
                  showSimilaridad.style.display = ""

                  chunk = ""
                }

                if (/[+-]?\d+(\.\d+)?/g.test(chunk)) {
                  
                  similaridad = Math.round(parseFloat(chunk*100))
                  showSimilaridad.innerHTML = `<i class="fa fa-check text-info" aria-hidden="true"></i> ` + similaridad.toString() + "% of similarity"
                  showSimilaridad.style.display = ""

                  chunk = ""
                }
              }*/
              
              for( let character of chunk) {
                  await sleep(speedPerLetter);
                  resp.value = resp.value + character
              }
              counter = counter + 1
            }

            botonTitular.style.display = ""
            botonSecundario.style.display = "none"
        }

        function sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }

        streamData().catch(console.error);

        //this.llamada.generation(body, this.generateRsp.bind(this))
      },

      generateRsp(rsp) {
        
        if (typeof rsp === 'undefined') {
          this.loading = false
          this.answer = ""
          this.noRelated = true

          setTimeout(() => {
            this.noRelated = false
          }, 5000)
          return
        }

        if (rsp.new_email) {
          this.loading = false
          this.answer = rsp.new_email
          this.similaridad = rsp.similaridad
          this.historico = rsp.historico

        } else {
          this.loading = false
          this.answer = ""
          this.noRelated = true

          setTimeout(() => {
            this.noRelated = false
          }, 5000)
        }

        
      },

      userInfoRsp(rsp) {
        let collecciones = []
        for (let i = 0; i < Object.keys(rsp.data.collections).length; i++) {
          collecciones.push({
            "name": Object.keys(rsp.data.collections)[i],
            "token": Object.values(rsp.data.collections)[i]
          })
        }

        localStorage.collections = JSON.stringify(collecciones)

        this.collections = JSON.parse(localStorage.collections)

        
      },

      copy() {
        let answer = document.getElementById("respuesta")
        navigator.clipboard.writeText(answer.value);

        this.copied = true

        setTimeout(() => {
          this.copied = false
        }, 3000)
      },

      sendFeedback(feedback) {

        let body = {
          "id": localStorage.genId,
          "feedback": feedback
        }

        this.llamada.feedback(body, this.feedbackRsp.bind(this))
      },

      feedbackRsp(rsp) {
        if (rsp.status === 200) {
          this.feedbackSent = true

          setTimeout(() => {
            this.feedbackSent = false
          }, 2000)
        } else {
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 2000)
        }

        let feedback = document.getElementById("feedback")
            feedback.style.display = "none"
      },

      newEmailFeedback() {

        let team = document.getElementById('selectorTeam')
        let answer = document.getElementById("respuesta")

        let body = {
          'email_received': this.mail,
          'email_sended': answer.value,
          "collection": team.value
        }

        this.llamada.newEmail(body, this.emailRsp.bind(this))
      },

      emailRsp(rsp) {
        if (rsp.status === 200) {
          this.emailAdded = true

          setTimeout(() => {
            this.emailAdded = false
          }, 2000)
        } else {
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 2000)
        }
      }
    }
  };
</script>

<style scoped>
.form-group {
  padding: 15px 15px 0px;
}
</style>
